import * as React from "react";
import { toast } from "react-toastify";
import { Button } from "@mui/material";
import { WhatsappJoinDialog } from "./WhatsappJoinDialog";

import { config } from "../env/config";
import { getUserKey, postData } from "../common/utils";
import { Loader } from "../common/loader/Loader";
import { SpecialDhPlans } from "./SpecialDhPlans";
import { useState } from "react";
import RegistrationPaymentDialog from "../login/RegistrationPaymentDialog";
import { displayRazorpayPaymentSdk } from "../payment/payment";

export const PayNowButton = ({ event, refreshEvents }) => {
    const [showLoader, setShowLoader] = useState(false);

    const [paymentUpdateResponse, setPaymentUpdateResponse] = useState(null);
    const [specialDhPlans, setSpecialDhPlans] = useState([]);
    const [showSpecialDHModal, setShowSpecialDHModal] = useState(false);
    const [registrationPaymentStatus, setRegistrationPaymentStatus] =
        useState("");

    const userData = getUserKey();

    const sendEventPaymentUpdate = async (response, selectedPlan) => {
        let payload = {
            booked_by: userData.name,
            country_id: userData.country_id,
            email: userData.email,
            event: {
                booking_enddate: event.booking_enddate,
                booking_endtime: event.booking_endtime,
                btnStatus: event.btnStatus,
                eventCancelReason: event.eventCancelReason,
                eventStatus: event.eventStatus,
                event_amount: event.event_amount,
                event_for: event.event_for,
                event_time: event.event_time,
                event_type: event.event_type,
                eventdate: event.eventdate,
                eventname: event.eventname,
                id: event.id,
                isCancel: event.isCancel,
                participant: event.participant,
            },
            member_id: userData.member_id,
            online_payment_id: response.onlinePaymentId,
            order_id: response.razorpay_order_id,
            payment_status: "success",
            signature: response.razorpay_signature,
            state_id: userData.state_id,
            transaction_id: response.razorpay_payment_id,
            user_id: userData.id,
        };

        if (config.env === "specialdh" && selectedPlan) {
            payload = {
                ...payload,
                event: {
                    ...payload.event,
                    event_amount: selectedPlan.specialPlanAmount,
                },
                ...selectedPlan,
            };
        }

        const res = await postData({
            url: `${config.serverUrl}/eventBooking.php`,
            payload,
            highlightError: true,
        });
        setShowLoader(false);
        if (res) {
            toast.success("Booking Successful!");

            if (res.whatsapplink) {
                setPaymentUpdateResponse(res);
            } else {
                hideWhatsappDialog();
            }
        }
    };

    const hideWhatsappDialog = () => {
        setPaymentUpdateResponse(null);
        refreshEvents();
    };

    const handleSpecialDhEventBooking = async () => {
        const payload = {
            user_id: userData.id,
            member_id: userData.member_id,
            event_id: event.id,
        };

        const res = await postData({
            url: `${config.serverUrl}/getSpecialPlanListandPlanAmount.php`,
            payload,
            highlightError: true,
        });
        if (res) {
            setSpecialDhPlans(res);
            setShowSpecialDHModal(true);
        } else {
            setShowLoader(false);
            toast.error("Something went wrong!");
        }
    };

    const submitRegistrationPayment = () => {
        makeRegistrationPayment();
    };

    const makeRegistrationPayment = async () => {
        const payload = {
            mobile: registrationPaymentStatus.mobile,
            memberId: registrationPaymentStatus.memberId,
            name: registrationPaymentStatus.name,
            amount: registrationPaymentStatus.regAmount * 100,
            currency: registrationPaymentStatus.currency,
            email: registrationPaymentStatus.email,
            description: "Registration",
            apkRefNo: `${registrationPaymentStatus.memberId}${Number(new Date())}`,
            bookInfo: "Sign up Payment",
        };

        try {
            const res = await postData({
                url: `${config.serverUrl}/getRazorpayOrderId.php`,
                payload,
                highlightError: true,
            });

            if (res) {
                displayRazorpayPaymentSdk({
                    ...res,
                    setShowLoader,
                    onPaymentSuccess: sendRegistrationPaymentUpdate,
                });
            } else {
                toast.error("Something went wrong!");
            }
        } catch (error) {
            toast.error("Something went wrong!");
            console.log("Something went wrong");
        }
    };

    const sendRegistrationPaymentUpdate = async (response) => {
        const payload = {
            booked_by: userData.name,
            country_id: userData.country_id,
            member_id: userData.member_id,
            online_payment_id: response.onlinePaymentId,
            order_id: response.razorpay_order_id,
            payment_status: "success",
            signature: response.razorpay_signature,
            state_id: userData.state_id,
            transaction_id: response.razorpay_payment_id,
            user_id: userData.id,
        };

        const res = await postData({
            url: `${config.serverUrl}/singupPaymentCheckout.php`,
            payload,
            highlightError: true,
        });

        setShowLoader(false);

        if (res) {
            setRegistrationPaymentStatus("");
            toast.success(
                "Registration Update Successful! You can now book events.",
            );
        }
    };

    const onBookEventClickHandler = async (selectedPlan) => {
        setShowLoader(true);
        try {
            const payload = {
                mobile: userData.mobile,
                description: "Event Booking",
                userId: userData.member_id,
                currency: userData.currency,
                email: userData.email,
                apkRefNo: `${userData.member_id}${Number(new Date())}`,
                bookInfo: `${event.eventname} ${event.eventdate}`,
                booked_by: userData.name,
                event_amount: selectedPlan
                    ? Number(selectedPlan.specialPlanAmount)
                    : Number(event.event_amount),
                event_for: event.event_for,
                eventname: event.eventname,
                eventid: event.id,
                participant: event.participant,
            };

            const res = await postData({
                url:
                    config.env === "dh"
                        ? `${config.serverUrl}/getEventBookOrderId_new.php`
                        : `${config.serverUrl}/getEventBookOrderId.php`,
                payload,
                highlightError: true,
            });

            setShowLoader(false);

            if (res && res.regStatus === 0) {
                setRegistrationPaymentStatus(res);
                setShowLoader(false);
                return;
            }

            if (res && res.status !== "failed") {
                displayRazorpayPaymentSdk({
                    ...res,
                    setShowLoader,
                    onPaymentSuccess: (response) =>
                        sendEventPaymentUpdate(response, selectedPlan),
                });
            }
        } catch (error) {
            setShowLoader(false);
            toast.error("Something went wrong!");
            console.log("Something went wrong");
        }
    };

    const onContinueHandler = (selectedPlan) => {
        setShowSpecialDHModal(false);
        onBookEventClickHandler(selectedPlan);
    };

    return (
        <>
            <Button
                variant="contained"
                size="small"
                onClick={
                    config.env === "specialdh"
                        ? handleSpecialDhEventBooking
                        : () => onBookEventClickHandler()
                }
                sx={{
                    width: { xs: "100%", md: "220px" },
                    height: "40px",
                    background: "#9045BF",
                    display: `${event.isCancel === "1" ? "none" : "flex"}`,
                }}
            >
                BOOK YOUR SEAT
                <Loader show={showLoader} />
            </Button>

            {/* Show join whatsapp button when update response contains whatsappLink */}
            {paymentUpdateResponse?.whatsapplink ? (
                <WhatsappJoinDialog
                    show={paymentUpdateResponse.whatsapplink}
                    primaryMsg={paymentUpdateResponse.first}
                    secondaryMsg={paymentUpdateResponse.second}
                    whatsappLink={paymentUpdateResponse.whatsapplink}
                    onCloseHandler={hideWhatsappDialog}
                />
            ) : null}

            {specialDhPlans && showSpecialDHModal ? (
                <SpecialDhPlans
                    onContinue={onContinueHandler}
                    show={showSpecialDHModal}
                    specialDhPlans={specialDhPlans}
                    onCloseHandler={() => {
                        setShowSpecialDHModal(false);
                    }}
                />
            ) : null}

            {registrationPaymentStatus && (
                <RegistrationPaymentDialog
                    onSubmit={submitRegistrationPayment}
                    state={registrationPaymentStatus}
                    onClose={() => setRegistrationPaymentStatus("")}
                />
            )}
        </>
    );
};
